import { atom } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'

import { reatomActivePosition } from '../../position/active-position'

import { tradingPairAddressAtom } from './trading-pair'
import { tradingWalletIdAtom } from './trading-wallet'

export const activePairPositionModel = atom((ctx) => {
  const pairAddress = ctx.spy(tradingPairAddressAtom)
  const network = ctx.spy(selectedNetworkAtom)
  const walletId = ctx.spy(tradingWalletIdAtom)

  if (!pairAddress || !walletId) {
    return
  }

  // eslint-disable-next-line @reatom/unit-naming-rule
  return reatomActivePosition({ pairAddress, network, walletId })
}, 'activePairPositionModel')

export const activePairPositionStateAtom = atom((ctx) => {
  const pairAddress = ctx.spy(tradingPairAddressAtom)
  const walletId = ctx.spy(tradingWalletIdAtom)
  if (!pairAddress || !walletId) {
    return AsyncStateN.success(undefined)
  }

  const model = ctx.spy(activePairPositionModel)
  return model ? ctx.spy(model) : AsyncStateN.notInitiated()
}, 'activePairPositionStateAtom')

export const activePairPositionAtom = atom(
  (ctx) => ctx.spy(activePairPositionStateAtom).value,
  'activePairPositionAtom',
)
